import { emailQuery } from "./emailQuery";

// The query part for getCustomer-by-Email and customers/update (ADM-66):
// emailQuery(email), plus `&branch_id=<id>` naming the branch the Customer was
// opened from, so a Customer with rows in two branches gets that branch's row,
// not the lowest-id row the caller covers. With no branch id (null, undefined
// or "") it is exactly emailQuery(email), the call as it was before.
//
// Pure. The id is encoded as well; it is not validated here (the admin answers
// 400 for a malformed one). __tests__/customerByEmailQuery.test.js checks it
// and that the live calls use it.
const NO_BRANCH = [null, undefined, ""];

export function customerByEmailQuery(email, branchId) {
  const query = emailQuery(email);
  if (NO_BRANCH.includes(branchId)) return query;
  return `${query}&branch_id=${encodeURIComponent(branchId)}`;
}
